import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** The state a coverage row reads as: the icon is the admission reason, the tone the color. */
export type CoverageStateTone = 'covered' | 'partial' | 'excluded' | 'uncovered';

/**
 * A breakdown row's merged State cell for the coverage detail list-table. One cell carries both the
 * admission criterion (the check / cross) and the verdict word, so the list needs no separate Allowed
 * and Verdict columns. Presentational: the row's tone and label are set by the content component.
 */
@Component({
    selector: 'app-coverage-state-cell',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span class="cst cst--{{ tone }}">
            @switch (tone) {
                @case ('covered') {
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7" /></svg>
                }
                @case ('excluded') {
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                        stroke-width="3" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
                }
                @case ('partial') {
                    <svg viewBox="0 0 24 24" width="15" height="15"><circle cx="12" cy="12" r="9" fill="none"
                        stroke="currentColor" stroke-width="2.4" /><path d="M12 3.3a8.7 8.7 0 0 0 0 17.4z"
                        fill="currentColor" /></svg>
                }
                @default {
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                        stroke-width="2.2"><circle cx="12" cy="12" r="9" stroke-dasharray="1.6 3.2"
                        stroke-linecap="round" /></svg>
                }
            }
            {{ label }}
        </span>
    `,
    styles: [
        `
            :host {
                --cst-covered: #146a39;
                --cst-amber: #8a6800;
                --cst-grey: #5b6472;
            }
            .cst {
                display: inline-flex;
                align-items: center;
                gap: 0.4rem;
                font-size: 0.75rem;
                font-weight: 700;
                white-space: nowrap;
            }
            .cst svg {
                flex: none;
            }
            .cst--covered {
                color: var(--cst-covered);
            }
            .cst--partial,
            .cst--excluded {
                color: var(--cst-amber);
            }
            .cst--uncovered {
                color: var(--cst-grey);
            }
        `,
    ],
})
export class CoverageStateCellComponent {
    @Input() tone: CoverageStateTone = 'uncovered';
    @Input() label = '';
}
